import React from 'react'
import { useTranslation } from 'react-i18next'
import { Paragraph } from 'suomifi-ui-components'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import { InfoInlineAlert } from 'todistukset-ui/src/vtj/components/order-wizard/CommonFormComponents.sc'

const EidasCheckYourInfoInlineAlert: React.FC = () => {
  const { t } = useTranslation()
  return (
    <InfoInlineAlert
      ariaLiveMode="off"
      status="warning"
      labelText={t('orderWizardEidasCheckYourInfoInlineAlertTitle')}
      data-test-id="eidas-check-your-info"
    >
      <Paragraph>
        <LocalizedString stringKey="orderWizardEidasCheckYourInfoInlineAlertText" />
      </Paragraph>
    </InfoInlineAlert>
  )
}

export default EidasCheckYourInfoInlineAlert
